import { render, staticRenderFns } from "./races.vue?vue&type=template&id=5ebcc3a0"
import script from "./races.vue?vue&type=script&lang=js"
export * from "./races.vue?vue&type=script&lang=js"
import style0 from "./races.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/races.vue
// module id = 0EOD
// module chunks = 0